import { z } from 'zod';
export const sixtyDaySummaryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        homeBoundStatus: z.array(z.string()).min(1, 'Please select at least one'),
        homeBoundStatusOther: z.string().nullish(),
        patientCondition: z.array(z.string()).min(1, 'Please select at least one'),
        servicesProvided: z.array(z.string()).min(1, 'Required'),
        servicesRecommended: z.array(z.string()).optional(),
        vitals: z
            .object({
            bp: z.object({
                systolic: z.object({
                    highest: z.string().optional(),
                    lowest: z.string().optional(),
                }),
                diastolic: z.object({
                    highest: z.string().optional(),
                    lowest: z.string().optional(),
                }),
            }),
            heartRate: z.object({
                highest: z.string().optional(),
                lowest: z.string().optional(),
            }),
            respiratory: z.object({
                highest: z.string().optional(),
                lowest: z.string().optional(),
            }),
            temperature: z.object({
                highest: z.string().optional(),
                lowest: z.string().optional(),
            }),
            weight: z.object({
                highest: z.string().optional(),
                lowest: z.string().optional(),
            }),
            bloodSugar: z.object({
                highest: z.string().optional(),
                lowest: z.string().optional(),
            }),
            pain: z.object({
                highest: z.string().optional(),
                lowest: z.string().optional(),
            }),
        })
            .optional(),
        summaryOfcare: z.string().min(1, 'required'),
        ptCurrentCondition: z.string().min(1, 'required'),
        goals: z.string().min(1, 'required'),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
